export default {"src":"/_next/static/media/metamask.73a87475.svg","height":32,"width":32};